import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router';

const AuthRoute = ({
  type,
  path,
  children,
}) => {
  const { isAuthenticated } = useSelector(({ auth }) => auth);

  if (type === 'guest' && isAuthenticated) {
    return <Redirect to="/dashboard" />;
  }
  if (type === 'private' && !isAuthenticated) {
    const redirect = window.location.pathname;
    return <Redirect to={`/${redirect ? `?redirect=${redirect}` : ''}`} />;
  }

  return (
    <Route path={path}>
      { children }
    </Route>
  );
};

AuthRoute.propTypes = {
  type: PropTypes.oneOf(['guest', 'private']),
  path: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
};

AuthRoute.defaultProps = {
  type: 'guest',
};

export default AuthRoute;
